
import React from 'react'
import DocumentMeta from 'react-document-meta'
import ShowHide from 'ui/ShowHide'
import LoggedOutHeader from './LoggedOutHeader'
import ForgotError from './ForgotError'
import ForgotDone from './ForgotDone'
import ForgotForm from './ForgotForm'
import ResetFooter from './ResetFooter'
import css from './Forgot.module.css'

const Forgot = props => (
  <div className={css.main}>
    <DocumentMeta title='Forgot - Segment' />

    <LoggedOutHeader title='Reset Your Password' />

    <ShowHide show={props.error}>
      <ForgotError wrongEmail={props.error && props.error.status === 404} />
    </ShowHide>

    <ShowHide show={props.success}>
      <ForgotDone />
    </ShowHide>

    <ShowHide show={!props.success}>
      <ForgotForm
        onSubmit={data => props.onSubmit(data.email)}
        email={props.email}
        onEnterEmail={props.onEnterEmail}
        isLoading={props.isRequesting}
        error={props.error} />
    </ShowHide>

    <ResetFooter />
  </div>
)

export default Forgot



// WEBPACK FOOTER //
// ./components/Forgot.js